(() => {
  function initialize() {
    document.querySelectorAll('.cc-article-table').forEach(region => {
      if (region.dataset.ccScrollCue) return;
      region.dataset.ccScrollCue = 'true';
      const hint = document.createElement('p');
      hint.className = 'cc-table-hint';
      hint.id = 'cc-table-hint-' + Array.from(document.querySelectorAll('.cc-table-hint')).length;
      hint.textContent = region.closest('[data-cc-table-hint]')?.dataset.ccTableHint || 'Swipe or scroll to see more columns.';
      region.before(hint);
      const describedBy = region.getAttribute('aria-describedby');
      region.setAttribute('aria-describedby', [describedBy, hint.id].filter(Boolean).join(' '));
      function update() {
        const overflow = region.scrollWidth > region.clientWidth + 1;
        hint.hidden = !overflow;
        region.classList.toggle('cc-has-more', overflow && region.scrollLeft + region.clientWidth < region.scrollWidth - 2);
      }
      region.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      if (window.ResizeObserver) new ResizeObserver(update).observe(region);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
